module.exports = __webpack_public_path__ + "static/media/2.Electric Chainsaw.055a539b.jpeg";